import angular from 'angular';

const evaluationsServices = angular.module('applicationModule.evaluationsServices', []);

evaluationsServices.factory('Evaluations', ['EvaluationsAPI', function (EvaluationsAPI) {
    'use strict';

    return {
        get: function (appId) {
            return EvaluationsAPI.get(appId);
        }
    };
}]);

evaluationsServices.service('EvaluationsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';
    const API_URL = AppsoupAPI.API_URL + '/app/evaluations/';

    this.get = function () {
        return $http.get(API_URL);
    };
}]);

export default evaluationsServices;
